function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
export var appendEach = function appendEach(arr, suffix) {
  return arr.filter(function (c) {
    return c;
  }).map(function (text) {
    return text + suffix;
  });
};
export var distinct = function distinct(array) {
  var keySelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (item) {
    return item;
  };
  var unique = new Map();
  var distinctArray = [];
  array.forEach(function (item) {
    var itemKey = keySelector(item);
    if (!unique.has(itemKey)) {
      distinctArray.push(item);
      unique.set(itemKey, item);
    }
  });
  return distinctArray;
};
export var findIndexOfObject = function findIndexOfObject(array, key, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][key] === value) {
      return i;
    }
  }
  return undefined;
};
export var updateObjectInArray = function updateObjectInArray(array, action) {
  if (typeof action.index !== 'number') {
    return [].concat(_toConsumableArray(array), [action.item]);
  }
  return array.map(function (item, index) {
    if (index !== action.index) {
      return item;
    }
    return Object.assign({}, item, action.item);
  });
};